import { useState } from "react"
/* form select */
import Select from 'react-select'
import selectStyles from "../../../../../shared/css/SelectStyle"
import Input from "../../../../../shared/components/form/input"
import FormLayout from "../../../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../../../shared/components/FormLayout/FormSection"
import Button from "../../../../../shared/components/Button/Button"
import NumberToMoney from "../../../../../shared/functions/NumberToMoney"

// hooks
import useFlashMessage from "../../../../../hooks/useFlashMessage"

function FormPrint({ btCancelAction, btnText, handleOnSubmit, title }) {
    const { setFlashMessage } = useFlashMessage()
    const [print, setPrint] = useState({})

    //------------------------------ Select Handle On Change --------------------------
    const handleSelectChange = (selectedOption) => {
        setPrint({ ...print, [selectedOption.selectName]: selectedOption })
    }

    const handleChange = (e) => {
        setPrint({ ...print, [e.target.name]: e.target.value })
    }
    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {
        let value = NumberToMoney(e.target.value)
        setPrint({ ...print, [e.target.name]: value })
    }

    const submit = () => {
        let id = Date.now();
        let data = print
        data = { ...data, _id: id }

        if (!data.position) {
            setFlashMessage("Selecione uma posição ", 'error')
            return
        }
        if (!data.description) {
            setFlashMessage("Informe uma descrição ", 'error')
            return
        }
        if (!data.price || parseFloat(data.price) <= 0) {
            setFlashMessage("Informe um valor ", 'error')
            return
        }

        handleOnSubmit(data)
    }
    const selectOptions = [
        { selectName: "position", value: "rightChest", label: "Peito direito" },
        { selectName: "position", value: "leftChest", label: "Peito esquerdo" },
        { selectName: "position", value: "back", label: "Costas" },
        { selectName: "position", value: "rightSleeve", label: "Manga direita" },
        { selectName: "position", value: "leftSleeve", label: "Manga esquerda" },
    ]

    return (
        <FormLayout
            title={title}
            actions={
                <>
                    <Button variant="save" onClick={submit}>{btnText}</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Detalhes">
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <label htmlFor="position">Posição:</label>
                        <Select
                            inputId="position"
                            options={selectOptions}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={print.position || ""}
                            placeholder="Selecione..."
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Preço"
                            type="number"
                            name="price"
                            placeholder="Preço"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={print.price || 0}
                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Descrição"
                            type="text"
                            name="description"
                            placeholder="descrição"
                            handleOnChange={handleChange}
                            value={print.description || ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormPrint
